import { render, staticRenderFns } from "./WidgetBox.vue?vue&type=template&id=c35422aa"
import script from "./WidgetBox.vue?vue&type=script&lang=js"
export * from "./WidgetBox.vue?vue&type=script&lang=js"
import style0 from "./WidgetBox.vue?vue&type=style&index=0&id=c35422aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VToolbarTitle})
